import { render, staticRenderFns } from "./NavigationLink.vue?vue&type=template&id=74e5d919&scoped=true&"
import script from "./NavigationLink.vue?vue&type=script&lang=ts&"
export * from "./NavigationLink.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationLink.vue?vue&type=style&index=0&id=74e5d919&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e5d919",
  null
  
)

export default component.exports